module.exports = __webpack_public_path__ + "img/evering_rd_b1.4d8dc0e3.jpg";